import { Controller } from "@hotwired/stimulus"
import { apiJson, formatApiErrorDetail } from "../lib/api_errore"

// ImpresaDaPiva di components/ImpresaDaPiva.js (31a5bd1, delta C6). Il valore è quello del componente React:
// null, { pending: true } durante il recupero, { record, confermata, usaSede } dopo. Ogni cambio esce con l'evento
// "impresa-da-piva:cambiata" (detail.value), che trova_controller.js usa per l'attesa e per unisciImpresa.
// Al caricamento (e a ogni rimonta, al ritorno al passo 0) solo GET /api/finder/impresa/configurazione; nessun
// recupero a pagamento senza «Recupera dati impresa». I dati del fornitore entrano solo come testo.
export default class extends Controller {
  static targets = ["piva", "recupera", "spento", "acceso", "limite", "errore", "dati", "prova", "denominazione", "partitaIva",
    "sede", "fonte", "limiteDati", "conferma", "sedeScelta", "usaSede", "scarta"]

  // montato solo al passo 0 (canEdit && step === 0): nascosto all'avvio (?project=) non legge nulla finché non torna
  connect() {
    this.value = null
    if (this.element.hidden) this.disegna()
    else this.rimonta()
  }

  disconnect() {
    this.attivo = false
  }

  // il remount del componente: partita IVA dal valore, configurazione riletta, nessun errore
  rimonta() {
    this.pivaTarget.value = this.value?.record?.dati?.partita_iva || ""
    this.config = null
    this.busy = false
    this.errore = ""
    this.attivo = true
    const richiesta = (this.richiesta = apiJson("/api/finder/impresa/configurazione"))
    richiesta.then((data) => { if (this.attivo && richiesta === this.richiesta) { this.config = data; this.disegna() } })
      .catch(() => {
        if (this.attivo && richiesta === this.richiesta) {
          this.errore = "Disponibilità del recupero anagrafico non verificabile. Puoi continuare con l’idea."
          this.disegna()
        }
      })
    this.disegna()
  }

  onChange(v) {
    this.value = v
    this.disegna()
    this.dispatch("cambiata", { detail: { value: v } })
  }

  piva() {
    this.errore = ""
    this.onChange(null)
  }

  async cerca() {
    this.busy = true; this.errore = ""
    this.onChange({ pending: true })
    try {
      const data = await apiJson("/api/finder/impresa", { method: "POST", body: { partita_iva: this.pivaTarget.value } })
      this.busy = false
      this.onChange({ record: data, confermata: false, usaSede: false })
    } catch (e) {
      this.busy = false
      this.errore = formatApiErrorDetail(e.detail) || "Recupero non riuscito. Puoi continuare compilando il profilo."
      this.onChange(null)
    }
  }

  confermata(event) {
    this.onChange({ ...this.value, confermata: event.target.checked })
  }

  usaSede(event) {
    this.onChange({ ...this.value, usaSede: event.target.checked })
  }

  scarta() {
    this.pivaTarget.value = ""
    this.errore = ""
    this.onChange(null)
  }

  disegna() {
    const config = this.config, record = this.value?.record, dati = record?.dati
    const prova = record?.ambiente === "sandbox"
    this.pivaTarget.disabled = this.busy
    this.recuperaTarget.disabled = this.busy || !config?.disponibile || !this.pivaTarget.value.trim()
    this.recuperaTarget.textContent = this.busy ? "Recupero dati…" : "Recupera dati impresa"
    this.spentoTarget.hidden = !(config && !config.disponibile)
    this.accesoTarget.hidden = !config?.disponibile
    this.limiteTarget.textContent = String(config?.limite_org_giorno ?? "")
    this.erroreTarget.hidden = !this.errore
    this.erroreTarget.textContent = this.errore
    this.datiTarget.hidden = !dati
    if (dati) {
      this.provaTarget.hidden = !prova
      this.denominazioneTarget.textContent = dati.denominazione ?? ""
      this.partitaIvaTarget.textContent = `Partita IVA: ${dati.partita_iva ?? ""}`
      this.sedeTarget.textContent = `Sede legale: ${[dati.indirizzo, dati.comune_fonte, dati.provincia_fonte, dati.cap].filter(Boolean).join(", ") || "Non restituita"}`
      this.fonteTarget.textContent = `Fonte: ${record.fonte} · Recuperato il ${new Date(record.recuperato_il).toLocaleString("it-IT")}${record.risposta_riutilizzata ? " · Risposta riutilizzata" : ""}`
      this.limiteDatiTarget.textContent = `${record.limite} Per gli altri dati potrai completare il profilo o usare una visura nel progetto.`
      this.confermaTarget.disabled = prova
      this.confermaTarget.checked = this.value.confermata || false
      this.sedeSceltaTarget.hidden = !dati.sede_legale
      this.usaSedeTarget.disabled = prova
      this.usaSedeTarget.checked = this.value.usaSede || false
    }
    this.scartaTarget.hidden = !record
    this.scartaTarget.disabled = this.busy
  }
}
